import React from 'react'
import { inject, observer } from 'mobx-react'
import IconMarker from './IconMarker'
import { defaultMarkerColor } from '../../constants'

/**
 * Renders the draft marker from poi.draftMarker when in draft mode.
 * This allows the marker to stay visible even after the selection is cleared.
 */
const DraftMarkerLayer = ({ dataStore, uiStore }) => {
  const poi = dataStore && dataStore.poi
  const draftMarker = poi && poi.draftMarker

  // Only render if in draft mode and there's a draft marker
  if (!poi || !poi.isDraftMode || !draftMarker || !draftMarker.position) {
    return null
  }

  // Resolve color_id to actual color
  const colorItem = dataStore.markerColors.find(item => item.id === draftMarker.color_id)
  const resolvedColor = colorItem || { active_color: defaultMarkerColor }

  return (
    <IconMarker
      color={resolvedColor}
      position={{ lat: draftMarker.position.lat, lng: draftMarker.position.lng }}
      icon='custom-map-marker'
      bucketColor='#ffffff'
      className='custom-map-marker draft-marker'
      label={uiStore && uiStore.showMarkerLabels ? draftMarker.name : null}
    />
  )
}

export default inject('dataStore', 'uiStore')(observer(DraftMarkerLayer))
